import { render } from "./HeroLivePreview.vue?vue&type=template&id=6a5868d4&scoped=true"
import script from "./HeroLivePreview.vue?vue&type=script&lang=js"
export * from "./HeroLivePreview.vue?vue&type=script&lang=js"

import "./HeroLivePreview.vue?vue&type=style&index=0&id=6a5868d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a5868d4"

export default script